export default {"src":"/_next/static/media/ninety-percent.0d6d062b.svg","height":45,"width":103,"blurWidth":0,"blurHeight":0};